<template>
  <div id="user-area" class="level">
    <ul v-click-outside="hide" style="position:absolute; bottom:4px">
      <li class="ham-tab-ico">
        <a><i class="fa" :class="show ? 'fa-times' : 'fa-bars'" @click="show ? hide() : show=true"/></a>
      </li>
      <span v-if="permissionsLoaded && !hasTruckAccess">
        <template v-for="(tab, index) in tabs">
          <li :key="index" v-if="shouldShowTab(tab)" :class="[$route.name == tab.routerName ? 'active-tab' : 'non-active-tab']">
            <router-link
              :to="{ path: '/' + tab.router, query: tab.clean ? { clean: 'true' } : {} }"
              :style="getTabStyle(tab)"
              tag="a"
            >
              <icon :icoClass="getIconClass(tab)" :selected='tab.ico'/>
              <span>{{ $t(tab.name) }}</span>
            </router-link>
          </li>
        </template>
      </span>
      <li class="non-active-tab" :class="show ? '' : 'hide-tabs'" style="position:relative; border: 2px #D1D1D1 solid; border-radius: 0.3em;">
        <a @click="showUserConfig=!showUserConfig" >
          <icon icoClass='tab-ico' selected='config'/>
          <span>User Config</span>
        </a>
        <span id="buttons" v-if="showUserConfig">
          <div style="display: flex;justify-content: space-around;">
            <button :class="{'select': (lan === 'en')}" class="lang l-left" @click="changeLanguage('en')">EN</button>
            <button :class="{'select': (lan === 'pt')}" class="lang" @click="changeLanguage('pt')">PT</button>
            <button :class="{'select': (lan === 'mx')}" class="lang" @click="changeLanguage('mx')">MEX</button>
            <button :class="{'select': (lan === 'es')}" class="lang l-right" @click="changeLanguage('es')">ES</button>
          </div>
          <button class="is-small btn-black" @click="logout()">Log Out</button>
          <button class="is-small btn-black" style="height: 3em; line-height: 1em" @click="showChangeCompany=true">{{ $t('change_company') }}</button>
          <button class="is-small btn-black" style="height: 3em; line-height: 1em" @click="showChangePass=true">{{ $t('change_pass') }}</button>

          <modal-company v-if="showChangeCompany" @close="showChangeCompany=false"/>

          <modal v-if="showChangePass">
            <div slot="body">
              <h2>{{ $t('change_pass') }}</h2>
              <input type="password" placeholder="Old password" class="input modal-input" v-model="old_password">
              <input type="password" placeholder="New password" class="input modal-input" v-model="new_password1">
              <input type="password" placeholder="Repite new password" class="input modal-input" v-model="new_password2">
              <div style="text-align:center; padding-top:.8em">
                <button class="btn-blue" @click="changePassword()">{{ $t('save') }}</button>
                <button class="btn-black" @click="showChangePass=false">{{ $t('cancel') }}</button>
              </div>
            </div>
          </modal>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Modal from '@/components/Modal'
import ModalCompany from '@/components/ModalCompany'
import icon from './../svg/tabs'
export default {
  name: 'user-area',
  components: {
    icon,
    Modal,
    ModalCompany
  },
  props: ['user'],
  data () {
    return {
      tabs: [
        {
          name: 'dashboard',
          ico: 'dashboard',
          router: 'dashboard',
          routerName: 'dashboard',
          permission: 'seeDashboard',
          clean: false
        },
        {
          name: 'trucks',
          ico: 'trucks',
          routerName: 'trucks',
          router: 'trucks',
          permission: 'seeTrucks',
          clean: false
        },
        {
          name: 'expeditions',
          ico: 'expeditions',
          routerName: 'expeditions',
          router: 'expeditions',
          permission: 'seeExpeditions',
          clean: true
        },
        {
          name: 'receptions',
          ico: 'receptions',
          router: 'receptions',
          routerName: 'receptions',
          permission: 'seeReceptions',
          clean: true
        },
        {
          name: 'critical_lines',
          ico: 'criticalLines',
          router: 'critical-lines',
          routerName: 'critical-lines',
          permission: 'seeCriticalLines',
          clean: false
        },
        {
          name: 'tasks',
          ico: 'tasklist',
          router: 'task-list',
          routerName: 'task-list',
          permission: 'seeTasklist',
          clean: false
        },
        {
          name: 'bi',
          ico: 'bi',
          router: 'bi',
          routerName: 'bi',
          permission: 'seeBi',
          clean: false
        }
      ],
      loginSso: process.env.JWT_LOGIN,
      companyCode: process.env.COMPANY,

      permissionsLoaded: false,
      showChangeCompany: false,
      showUserConfig: false,
      showChangePass: false,
      show: false,

      new_password1: '',
      new_password2: '',
      old_password: '',
      lan: ''
    }
  },
  mounted () {
    this.lan = localStorage.getItem('vueml-lang')
    this.getUserAreaData()
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    test () {
      return this.$route.name
    },
    hasTruckAccess () {
      if (this.auth.userData && this.auth.userData.roles) {
        for (let rol of this.auth.userData.roles) {
          if (rol.description === 'acceso-camion') return true
        }
      }
    }
  },
  watch: { },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions',
      changePassword: 'auth/changePassword'
    }),
    changeLanguage (lg) {
      localStorage.setItem('vueml-lang', lg)
      this.$i18n.locale = localStorage.getItem('vueml-lang')
      this.lan = lg
    },
    logout () {
      if (this.loginSso) {
        this.$store.dispatch('auth/logoutSso').then(() => {})
      }
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login')
      })
    },
    changePassword () {
      if (this.new_password1 === this.new_password2) {
        this.changePassword({
          old_password: this.old_password,
          new_password: this.new_password1
        }).then(() => {
          this.clearFields()
          this.showChangePass = false
        })
      } else {
        this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('pass_different') })
      }
    },
    cancellation () {
      this.clearFields()
    },
    clearFields () {
      this.old_password = ''
      this.new_password1 = ''
      this.new_password2 = ''
    },
    hide () {
      this.show = false
      this.showUserConfig = false
    },
    shouldShowTab (tab) {
      const specialTabs = ['dashboard', 'trucks', 'critical_lines', 'tasks', 'bi', 'expeditions', 'receptions']
      return specialTabs.includes(tab.name) ? tab.canSee : true
    },
    getTabStyle (tab) {
      return tab.name === 'critical_lines' ? 'color: #CA4123 !important; border-color: #CA4123 !important; border: 2px #D1D1D1 solid; border-radius: 0.3em;' : 'border: 2px #D1D1D1 solid; border-radius: 0.3em;'
    },
    getIconClass (tab) {
      return tab.name === 'critical_lines' ? 'tab-ico-orange' : 'tab-ico'
    },

    // Async methods
    getPermissions () {
      const tabPermissions = this.tabs.map(tab => tab.permission)
      this.checkPermissions(tabPermissions).then(response => {
        this.tabs.forEach(tab => {
          if (tab.name === 'critical_lines') {
            tab.canSee = this.auth.hasCriticalLines && response[tab.permission]
          } else if (tab.name === 'tasks') {
            tab.canSee = this.auth.hasTasks && response[tab.permission]
          } else {
            tab.canSee = response[tab.permission]
          }
        })
        this.permissionsLoaded = true
      }).catch(() => {
        this.permissionsLoaded = true
      })
    },
    async getUserAreaData () {
      try {
        this.getPermissions()
      } catch (error) {
        console.error('Error getting user area:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.modal-input{
  margin-top: 10px
}
.button{
  font-weight: bold;
}
button {
  margin: .1em;
}
#buttons{
  padding: 3px 0;
  display: block;
  position: absolute;
  width: 15em;
  right: 0;
  text-align: right;
  .is-small{
    width: 100%;
  }
}
input[type="password"]{
  display: block;
  margin-left: auto;
  margin-right: auto;
}
h2 {
  text-transform: uppercase;
  color: #009D97;
}
.lang{
  width: 100%;
  font-family: MuseoSans-500;
  background: $k-lime;
  border: none;
  font-size: .9em;
  padding: .2em 0;
  margin: 0 !important;
  text-align: center;
  cursor: pointer;
  &:hover {
    font-weight: bolder;
    background-color: $k-lime-text;
  }
}
.l-left {
  border-top-left-radius: .2em;
  border-bottom-left-radius: .2em;
  margin-right: 0;
}
.l-right {
  border-top-right-radius: .2em;
  border-bottom-right-radius: .2em;
  margin-left: 0;
}
.select{
  font-family: MuseoSans-900;
  box-shadow: inset 0px 0px 5px 2px rgba($color: $k-turq, $alpha: .2);
}

</style>



// WEBPACK FOOTER //
// src/components/UserArea.vue